// 中文语言包（zh-CN）——全站唯一权威文案源，后续各页 Task 往此追加命名空间。
export default {
  brand: {
    name: "乐兔智能 Letoo AI",
    slogan: "不止给建议，帮你把 AI 真正长进业务里",
    subSlogan: "前沿部署工程师（FDE）交付，从业务诊断到私有化上线，最快 2 周见效。",
  },
  common: {
    ctaDiagnosis: "联系我们",
    ctaJoin: "加企业微信入群",
    exploreMore: "了解更多",
    // 预约诊断链接：占位，交付时替换为真实预约/表单地址（仓库外依赖）
    bookingUrl: "https://meetings-na2.hubspot.com/gf",
    disclaimer: "部分案例为脱敏演示示意。",
    qrDialogTitle: "联系我们",
    qrDialogCaption: "扫码添加企业微信，和我们聊聊",
    businessPhone: "业务电话",
  },
  nav: {
    home: "首页",
    solutions: "解决方案",
    cases: "客户案例",
    fde: "FDE 交付",
    courses: "课程",
    community: "开发者社群",
    about: "关于我们",
  },
  home: {
    hero: {
      eyebrow: "企业级 AI 落地服务", // 主标题上方的小标题 kicker
      title: "不止给建议，",
      titleSpan: "帮你把 AI 真正长进业务里", // 渲染在 .text-gradient span 内
      line3: "FDE 交付，最快 2 周见效",
      ctaPrimary: "AI 免费检测", // 主按钮，暂复用二维码弹窗；未来接留资表单
      ctaSecondary: "我们怎么做", // 次按钮，暂无跳转行为
      stats: [
        { num: "93%", text: "AI 项目卡在从试点到生产的最后一公里" },
        { num: "88%", text: "部署 AI 的企业已拿到正向 ROI" },
        { num: "2 周", text: "快赢试点最快见效周期" },
      ],
    },
    hook: {
      lead: "通用助手解决不了你的生意。我们派 FDE 驻场，把 AI 深度嵌入你的核心业务——精准诊断、闭环优化、量化 ROI，砍掉重复人力、放大人均产出，让 AI 成为你甩开对手的增长引擎。",
      cards: [
        {
          title: "只有建议，没有落地",
          line1: {
            num: "93%",
            text: "的 AI 项目卡在从试点到生产，方案漂亮却跑不进业务系统。",
          },
          line2: {
            num: "2.6 倍",
            text: "真正把 AI 跑进业务的企业，拿到回报的可能性远高于停在 PPT 的同行。",
          },
        },
        {
          title: "缺懂业务的工程手",
          line1: {
            num: "稀缺",
            text: "既懂大模型、又懂你行业流程、还能私有化交付的复合型人才。",
          },
          line2: {
            num: "90%",
            text: "的团队缺少能把模型接进现有系统的工程能力。",
          },
        },
        {
          title: "ROI 说不清、算不明",
          line1: {
            num: "?",
            text: "投入不小，效果却难量化，决策者迟迟不敢从试点走向规模化。",
          },
          line2: {
            num: "88%",
            text: "已部署 AI 的企业其实已拿到正向 ROI，只是多数人没算清。",
          },
        },
        {
          title: "数据知识散落，AI 用不起来",
          line1: {
            num: "80%",
            text: "企业数据是非结构化的，散落在文档、群聊、系统里，大模型接不上。",
          },
          line2: {
            num: "0 引用",
            text: "没有检索与溯源，AI 回答不可信、不敢用在业务上。",
          },
        },
        {
          title: "私有化部署，落不了地",
          line1: {
            num: "顾虑",
            text: "客户、订单、经营数据不敢交给公有云大模型，安全合规过不了内部这关。",
          },
          line2: {
            num: "自建难",
            text: "想私有化又缺 GPU、缺工程、缺运维，落地成本高、周期长，迟迟上不了线。",
          },
        },
        {
          title: "AI 上线即巅峰，不会自生长",
          line1: {
            num: "静态",
            text: "模型上线就定格，业务在变、数据在涨，AI 却不会跟着一起进化。",
          },
          line2: {
            num: "越用越差",
            text: "缺少反馈闭环与持续调优，效果随时间衰减，最终沦为摆设。",
          },
        },
      ],
      doingTitle: "我们做什么：知 · 行 · 行",
      doingDesc:
        "知——AI 布道与咨询，把大模型能力翻译成你业务的增长杠杆；行——FDE 交付，替你把 AI 跑进系统；行——Agent 定制开发，沉淀为可复利的资产。",
      checkTitle: "一套能力，跑通 AI 落地最后一公里",
      checklist: [
        "AI 布道与咨询：把大模型能力翻译成你业务的增长杠杆",
        "FDE 交付：从业务诊断到私有化上线，替你把 AI 跑进系统",
        "Agent 定制开发：沉淀为可复利的 Pre-built Agents 与连接器",
        "明确交付周期 + 量化 ROI + 复利资产，专治落地最后一公里",
      ],
    },
    content3: {
      title: "Letoo AI 用可落地的 Agent，<br />把大模型能力接进你的业务系统",
      subtitle: "以 AI 为增长副驾，从诊断到上线，替你跑通最后一公里。",
    },
    content4: {
      title: "各大行业，按你的场景定制 Agent",
      desc: "跨境电商、社媒创作运营与达人营销、供应链、制造业、医疗健康、法律与企服财税等各行业——我们按你的场景定制 Agent，把目标变成可量化的结果。",
    },
    whatWeHave: {
      kicker: "乐兔AI能力栈",
      title: "我们有什么",
      subtitle: "从企业级 AI 底座到会持续进化的组织能力，让 AI 真正长进你的业务里。",
      os: {
        label: "企业级 AI 操作系统",
        title: "让全公司与 AI 协同作战的底座",
        description: "以智能体协同平台为核心，支持私有化部署与深度定制，把重复劳动交给 Agent，让每个关键岗位都拥有专属 AI 支持，在提升效率的同时释放更多组织产能。",
        consoleTitle: "乐兔 · 企业 AI 操作系统",
        live: "实时 · 4 AGENTS",
        workspace: ["组织", "CRM", "审批", "进销存", "智能体"],
        capabilities: [
          { number: "01", title: "私有化部署", description: "数据与业务流程掌控在企业内部，核心资产不出境。" },
          { number: "02", title: "无缝对接现有系统", description: "将 AI 融入日常工作流，不另起炉灶。" },
          { number: "03", title: "全员 AI 协同", description: "让每个岗位都能与 AI 协同工作，而不是只有少数人使用 AI。" },
          { number: "04", title: "可扩展架构", description: "随业务发展持续构建专属 Agent，系统越用越强。" },
        ],
        agents: [
          { name: "销售询盘 Agent", status: "运行中", metric: "1,486 · 94%", metricLabel: "今日处理 · 解决率", bars: [16, 24, 20, 30, 26, 37, 32, 43] },
          { name: "合同/报价 Agent", status: "运行中", metric: "2,760 · 91%", metricLabel: "今日处理 · 解决率", bars: [20, 27, 25, 34, 31, 42, 38, 46] },
          { name: "知识库检索 Agent", status: "运行中", metric: "842 · 97%", metricLabel: "今日处理 · 解决率", bars: [12, 18, 25, 20, 32, 29, 40, 36] },
          { name: "审批流 Agent", status: "待命", metric: "196 · 88%", metricLabel: "今日处理 · 解决率", bars: [13, 17, 21, 29, 26, 34, 38, 45] },
        ],
        autoBuild: "需求 → AI Agent 自动实现（自生长）",
      },
      growth: {
        label: "自生长系统",
        title: "让技能、知识与工作流持续自我进化",
        description: "模型只是起点，真正可复利的是组织能力。我们把 FDE 的诊断、拆解、交付与迭代方法沉淀为可复用的 Agent，让企业的技能、知识和工作流在每次交付中持续积累、复用和升级。",
        steps: [
          { number: "01", title: "录制", description: "采集真实业务流程、专家判断与操作步骤。" },
          { number: "02", title: "回放", description: "将一次性交付沉淀为可复用、可审计的工作流。" },
          { number: "03", title: "蒸馏", description: "把专家经验转化为 Agent 能力，人负责兜底。" },
          { number: "04", title: "自生长", description: "随着使用次数增加，知识、技能和流程持续演进。" },
        ],
        nodes: [
          { index: "01", title: "真实流程", description: "采集专家工作方式", position: "top" },
          { index: "02", title: "Agent 执行", description: "在业务系统中运行", position: "right" },
          { index: "03", title: "结果复盘", description: "记录效果与异常", position: "bottom" },
          { index: "04", title: "方法沉淀", description: "转化为可复用能力", position: "left" },
        ],
      },
      cta: "查看 AI 落地方案",
    },
    whatWeDo: {
      title: "我们做什么",
      subtitle: "从看清现状到持续进化，把 AI 能力真正落进业务，并沉淀为可复用的组织资产。",
      eyebrow: "AI 原生交付体系",
      pillarsAria: "能力路径",
      mapAria: "从业务现状经过 AI 原生底座与方法体系走向可量化成果的交付路径",
      pillars: [
        { key: "know", title: "知", description: "AI 布道与咨询：理解业务现状，找到最值得落地的增长杠杆。" },
        { key: "act", title: "行", description: "FDE 交付：把诊断、开发、集成和上线变成可验证的业务结果。" },
        { key: "build", title: "建", description: "Agent 定制开发：构建能协同、能执行、能持续复用的智能体资产。" },
      ],
      map: {
        currentLabel: "你的现状",
        baseLabel: "AI 原生底座",
        resultLabel: "可量化结果",
        stages: [
          { title: "老旧系统升级", description: "评估现状、迁移流程，让旧系统重新具备生产力。", side: "current" },
          { title: "FDE 咨询规划", description: "围绕业务目标梳理场景，明确优先级与落地路径。", side: "current" },
          { title: "诊断", description: "一周深度诊断，完成现状与目标对齐，输出可落地的实施方案。", side: "method" },
          { title: "从 0 到 1 构建", description: "完成需求拆解、全栈交付与首个场景上线。", side: "method" },
          { title: "智能体协同平台", description: "私有化、可控、可扩展，让多个 Agent 协同工作。", side: "method" },
          { title: "AI知识库", description: "沉淀企业知识与业务经验，让 Agent 有依据地理解、检索并执行。", side: "method" },
          { title: "交付上线", description: "接入真实系统，交付可用、可衡量、可持续运行的 AI。", side: "result" },
          { title: "评估复盘", description: "用数据验证效果，持续优化流程、模型和协作方式。", side: "result" },
          { title: "自演进", description: "把每次交付沉淀为技能、知识与工作流，越用越强。", side: "result" },
        ],
      },
      foundation: {
        title: "AI 原生底座",
        description: "智能体协同平台",
        tags: ["知识库", "连接器", "FDE 方法"],
        loopLabel: "FDE 方法闭环",
        loopSteps: ["诊断", "拆解", "交付", "复盘"],
      },
      deliverablesTitle: "我们交付什么",
      deliverablesEyebrow: "交付内容",
      stageArrowLabel: "查看阶段详情",
      deliverables: [
        "AI 布道与咨询，帮助团队建立正确的 AI 认知与落地方法",
        "FDE 交付与私有化部署，让 AI 真正跑进企业系统",
        "Agent、Skills 与连接器定制，形成可复用的智能体资产",
        "明确交付周期、量化 ROI，并持续沉淀复利能力",
      ],
      cta: "查看 AI 落地方案",
    },
    flow: {
      title: "FDE 落地流程：从诊断到复利，交付看得见",
      steps: ["业务诊断", "场景选型", "2–4 周快赢试点", "私有化上线", "规模化复利"],
    },
    content6: {
      block1Title: "执行而非建议——我们替你把活干完",
      block1Desc:
        "FDE 交付，从业务诊断到私有化上线，明确交付周期、量化 ROI。不是交一份 PPT，而是交一套跑在你系统里的 AI。",
      block1List: [
        "业务诊断与选型",
        "私有化部署与联调",
        "上线后的效果度量与迭代",
      ],
      block2Title: "沉淀复利资产，越用越省",
      block2Desc:
        "每次交付都沉淀为 Pre-built Agents、评测集、SOP、Skills & MCP 连接器与脱敏数据集，下一个场景更快更便宜。",
      block2List: [
        "可复用的 Agent 与连接器",
        "行业 SOP 与评测集",
        "随规模摊薄的边际成本",
      ],
      ctaText: "聊聊你的业务，看看 AI 能落地在哪",
    },
    knowledge: {
      title: "AI 知识库：让企业知识真正用起来",
      subtitle:
        "把散落在文档、系统和员工经验里的知识，沉淀成人人可查、随时能用的资产，帮企业提效降本、服务更快、经验不流失。",
      cards: [
        { title: "响应更快，服务更好", desc: "客服、售前、售后一问即答，把资深员工的经验复制给每个人，回复更快、口径更统一，客户体验更好。" },
        { title: "新人快速上手", desc: "制度、流程、话术一处可查，培训周期大幅缩短，人力与试错成本更低，团队更快形成战斗力。" },
        { title: "经验沉淀不流失", desc: "把骨干的隐性经验变成企业资产，人员流动不再带走核心知识，组织能力持续复利。" },
        { title: "决策更有底气", desc: "每条回答都能查到出处、按权限可见，信息可信、安全合规，让业务决策又快又稳。" },
      ],
      flowTitle: "落地流程",
      flow: ["业务诊断", "场景选型", "2–4 周快赢试点", "私有化上线", "规模化复利"],
      ctaText: "把你的知识库跑起来，先聊聊你的场景",
    },
    // 核心价值仪表盘模块（渲染于「知·行·行」之上）；数据均为示意值，待替换
    coreValue: {
      title: "我们带来什么",
      subtitle: "把每一次执行变成可量化的效率、成本与增长，让价值看得见，也经得起复盘。",
      tags: ["原生智能", "稳定可靠", "智能升级"],
      impact: {
        badge: "LIVE",
        label: "技术投入 30 天",
        value: "80%",
        unit: "综合技术投入下降",
        note: "相当于用 AI Native 模式，省下一支自建技术团队",
        axisStart: "90 天前",
        axisEnd: "现在",
      },
      roi: {
        title: "roi",
        rows: [
          { label: "定制系统替代 SaaS 订阅", metric: "软件订阅成本省下", value: "60%" },
          { label: "内部管理系统自动化", metric: "人工统计工时压缩", value: "90%" },
          { label: "从月报到实时看板", metric: "经营决策提速", value: "2倍" },
        ],
      },
      agents: {
        title: "agents · 失败率",
        note: "近 30 天运行 · 失败率越低越好",
        list: [
          { name: "选品 Agent", rate: "0.7%", pct: 47 },
          { name: "补货 Agent", rate: "0.4%", pct: 27 },
          { name: "对账 Agent", rate: "0.2%", pct: 13 },
          { name: "物流跟单 Agent", rate: "1.3%", pct: 87 },
        ],
        more: "还有 12 个 Agent 在运行",
      },
      delivery: {
        title: "delivery",
        label: "2周交付",
        fast: { value: "2 周", desc: "最快交付上线" },
        resp: { value: "20 分钟", desc: "最快响应新需求" },
        compare: {
          rows: [
            { label: "传统交付", value: "数月", pct: 90, brand: false },
            { label: "Letoo AI", value: "2 周", pct: 16, brand: true },
          ],
        },
      },
    },
  },
  courses: {
    hero: {
      eyebrow: "AI FDE 课程 · 从认知到交付",
      title: "不是学会用 AI，\n而是学会把 AI 交付进业务",
      description: "从业务诊断、场景拆解，到 Agent 交付与持续迭代，建立一套回到工作中就能复用的 AI FDE 方法。",
      primaryCta: "了解个人课程",
      secondaryCta: "了解企业内训",
      stats: [
        { value: "3", label: "体系", caption: "职业 · 企业 · ", accent: "技术" },
        { value: "19", label: "模块", caption: "7 职业 · 9 企业 · 3 技术" },
        { value: "3+", label: "项目", caption: "邮件助手 · ReAct · SWE-bench" },
        { value: "200+", label: "", caption: "可复用 Skill" },
        { value: "4", label: "阶段", caption: "诊断 · 拆解 · 交付 · 迭代" },
        { value: "1", label: "用例", caption: "真实业务交付" },
      ],
      preview: {
        title: "Letoo Academy · AI FDE 课程",
        eyebrow: "课程工作台 · WORKSPACE",
        stages: [
          { id: "diagnose", number: "01", label: "诊断", title: "找到真正值得做的 AI 用例", description: "从业务目标、痛点频率和可量化价值出发，判断 AI 应该先解决什么。", lesson: "第 01 课 · 用例诊断", task: "识别真实业务瓶颈", progress: "24%", status: "已完成 2 / 4 项" },
          { id: "decompose", number: "02", label: "拆解", title: "把复杂问题变成可验证的 MVP", description: "把一个大目标拆成角色、数据、动作和验收标准都清晰的最小场景。", lesson: "第 02 课 · 场景拆解", task: "定义最小可交付范围", progress: "46%", status: "已完成 3 / 5 项" },
          { id: "deliver", number: "03", label: "交付", title: "让 Agent 跑进真实业务流程", description: "连接模型、工具与业务动作，让一个可验收的 Agent 工作流真正上线。", lesson: "第 04 课 · FDE 交付方法", task: "建立可复盘的工作闭环", progress: "68%", status: "已完成 3 / 4 项" },
          { id: "iterate", number: "04", label: "迭代", title: "用数据和复盘让系统持续变好", description: "用反馈、评测和复盘推动系统自我迭代，让一次交付变成长期能力。", lesson: "第 06 课 · 迭代闭环", task: "设计下一轮评测指标", progress: "86%", status: "已完成 4 / 5 项" },
        ],
      },
    },
    outcomes: {
      eyebrow: "学完你能带走什么",
      title: "带走的不是笔记，是能跑的系统",
      items: [
        { number: "01", title: "搭出 1 套会自我迭代的 AI 系统", description: "看懂老板、运营、Agent、数据与复盘如何协作，回到公司就能复用。" },
        { number: "02", title: "亲手做 3+ 个 Agent 项目", description: "从邮件助手、ReAct loop 到 SWE-bench，把真实作品直接写进简历。" },
        { number: "03", title: "上手 200+ 可复用 Skill", description: "覆盖诊断、交付与评测，把高手动作拆成可调度、可迭代的能力。" },
        { number: "04", title: "独立交付 1 个真实业务用例", description: "用四阶段方法论：诊断 → 拆解 → 交付 → 迭代，让一个场景在一周内上线。" },
      ],
    },
    lesson: {
      eyebrow: "课程内容长什么样",
      title: "每一页都讲透：是什么、为什么、怎么做",
      caption: "真实课程工作台",
      features: ["结论直接给你", "数据与判断有依据", "框架拿回去就能用", "案例讲清落地关键"],
      preview: {
        live: "实时笔记",
        label: "FDE 交付方法论",
        title: "把复杂业务，拆成能运行的 Agent 工作流",
        description: "先验证价值与可行性，再把人、数据、模型和动作连接成可复盘的闭环。",
        flow: ["业务问题", "最小场景", "可量化结果"],
        noteLabel: "关键洞见",
        note: "先让一个场景跑通，再让能力规模化。",
      },
    },
    curriculum: {
      eyebrow: "课程大纲 · CURRICULUM",
      title: "完整的课，不是几条 Prompt",
      chapterLabel: "Letoo Academy · chapter",
      tabs: [
        {
          id: "personal",
          label: "个人 · Series A",
          subtitle: "FDE 职业培训",
          modules: [
            { code: "M0", title: "入门破冰", subtitle: "别把 AI 当百度，先看清它解决什么", lessons: "4 课时", level: "起步" },
            { code: "M1", title: "FDE 是什么", subtitle: "你不是模型，是把它落进业务的人", lessons: "4 课时", level: "认知" },
            { code: "M2", title: "商业与咨询思维", subtitle: "客户买的不是软件，是一个被解决的问题", lessons: "5 课时", level: "方法" },
            { code: "M3", title: "AI 能力基线", subtitle: "它会什么、不会什么，先划清能力边界", lessons: "6 课时", level: "能力" },
            { code: "M4", title: "FDE 交付方法论", subtitle: "接的是 Mission，不是一纸功能清单", lessons: "5 课时", level: "交付" },
            { code: "M5", title: "FDE 全栈工具箱", subtitle: "模型很多，选对系统才叫 FDE", lessons: "7 课时", level: "实战" },
            { code: "M6", title: "职业定位与成长", subtitle: "FDE 不是终点，是创造人的训练场", lessons: "3 课时", level: "成长" },
          ],
        },
        {
          id: "enterprise",
          label: "企业 · Series B",
          subtitle: "企业 AI 落地",
          modules: [
            { code: "M0", title: "认知破壳", subtitle: "AI 认知破壳：看懂它，才敢用它", lessons: "3 课时", level: "起步" },
            { code: "M1", title: "为什么 AI 落地失败", subtitle: "95% 的 AI 试点没有回报，但失败有规律", lessons: "4 课时", level: "认知" },
            { code: "M2", title: "诊断：用例优先级", subtitle: "能用 AI 的地方一抓一大把，先做哪个？", lessons: "4 课时", level: "诊断" },
            { code: "M3", title: "拆解：用例到 MVP", subtitle: "选定了用例，下一步不是写代码", lessons: "4 课时", level: "拆解" },
            { code: "M4", title: "合规承重墙", subtitle: "合规不是附录，是承重墙", lessons: "4 课时", level: "合规" },
            { code: "M5", title: "交付：一周上线", subtitle: "Demo 能跑的很多，能验收上线的才算交付", lessons: "5 课时", level: "交付" },
            { code: "M6", title: "迭代：自运转机制", subtitle: "顾问会走，AI 得自己跑下去", lessons: "4 课时", level: "迭代" },
            { code: "I", title: "行业包 · 律所版", subtitle: "把 AI 落地框架，钉到律所的业务上", lessons: "4 课时", level: "行业" },
            { code: "C", title: "行业包 · 客服版", subtitle: "客服上 AI，不是上一个机器人", lessons: "4 课时", level: "行业" },
          ],
        },
        {
          id: "technical",
          label: "技术 · Series C",
          subtitle: "Agent 工程专题",
          modules: [
            { code: "C1", title: "Agent 从 0 搭", subtitle: "Agent 不是人格，是循环、状态与约束", lessons: "5 讲", level: "初阶" },
            { code: "C2", title: "框架与 RAG 工程", subtitle: "三大框架横览与 RAG 安全落地", lessons: "6 讲", level: "中阶" },
            { code: "C3", title: "评测、多 Agent 与上线", subtitle: "从能用，到能评测、编排和上线", lessons: "5 讲", level: "进阶" },
          ],
        },
      ],
    },
    framework: {
      eyebrow: "课上的方法武器",
      title: "你学的，就是我们交付时用的",
      cards: [
        { eyebrow: "方法论", title: "FDE 4 阶段闭环" },
        { eyebrow: "用例怎么选", title: "价值 × 可行 优先级" },
        { eyebrow: "FDE 凭什么", title: "FDE vs 其他角色" },
      ],
      priority: { xLabel: "可行性", yLabel: "价值", low: "别碰", high: "先做", best: "优先" },
      comparison: {
        roles: ["FDE", "咨询", "工程师"],
        rows: [
          { label: "懂业务", values: ["full", "full", "empty"] },
          { label: "懂工程", values: ["full", "empty", "full"] },
          { label: "驻场交付", values: ["full", "half", "empty"] },
          { label: "对结果负责", values: ["full", "half", "half"] },
        ],
      },
      steps: [
        { number: "01", title: "诊断", description: "建立用例优先级地图" },
        { number: "02", title: "拆解", description: "从用例到可验证 MVP" },
        { number: "03", title: "交付", description: "连接真实流程并上线" },
        { number: "04", title: "迭代", description: "形成自运转复利机制" },
      ],
    },
    programIntro: {
      eyebrow: "个人课程 · SERIES A · FDE 职业培训",
      titleLead: "FDE，是 AI 时代的",
      titleAccent: "超级个体",
      description: "Forward Deployed Engineer——驻场把 AI 落进真实业务的人。Palantir 发明、YC 在追，也是国内最稀缺、溢价最高的新职业。",
    },
    programs: {
      eyebrow: "两条路径 · PROGRAMS",
      title: "个人长本事，企业建系统",
      cards: [
        { key: "personal", eyebrow: "个人课程 · SERIES A", title: "成为能把 AI 交付进业务的 FDE", audience: "面向工程师、产品与希望转型的业务人才", bullets: ["FDE 能力模型：懂业务、懂工程、会交付", "全栈工具箱与真实 Agent 项目", "学习社群、答疑与作品集复盘"], price: "¥588 起", cta: "了解个人课程" },
        { key: "enterprise", eyebrow: "企业内训 · SERIES B", title: "把团队经验沉淀成可复用系统", audience: "面向老板、合伙人、业务负责人及团队", bullets: ["标准课程结合企业真实业务练习", "行业包与 Agent/Skill 能力地图", "诊断表、复盘模板与持续迭代机制"], price: "¥21,800 起 / 团队", cta: "了解企业内训" },
      ],
    },
    pricing: {
      eyebrow: "报名与企业内训 · ENROLL",
      title: "按你想走多深，选择对应路径",
      personalTitle: "个人课程",
      enterpriseTitle: "企业内训",
      featuredLabel: "推荐",
      personal: [
        { name: "标准班", price: "¥588", originalPrice: "原价 ¥699", features: ["7 个完整课程模块", "线上直播与录播回放", "学习社群与答疑"] },
        { name: "实战班", price: "¥888", originalPrice: "原价 ¥1,299", features: ["标准班全部内容", "真实交付项目带练", "作品集复盘与成长建议"], featured: true },
      ],
      enterprise: [
        { name: "小队 · ≤20 人", price: "¥21,800", features: ["标准课程全模块", "1 个行业包", "团队诊断表与复盘模板"] },
        { name: "部门 · 21–50 人", price: "¥31,800", features: ["标准课程全模块", "2 个行业包与业务练习", "Agent 角色图与 Skills 地图"], featured: true },
        { name: "公司 · 51–100 人", price: "¥51,800", features: ["多团队分层授课", "员工方法论蒸馏框架", "KPI 看板与持续陪跑接口"] },
        { name: "客户业务定制版", price: "+¥10,000 起", features: ["100 人以上团队", "私有化与长期陪跑", "按业务场景定制"] },
      ],
      cta: "咨询课程方案",
    },
    faq: {
      eyebrow: "保障与常见问题 · FAQ",
      title: "把不确定性，留给我们",
      items: [
        { question: "零基础可以学习个人课程吗？", answer: "可以。课程从业务场景和方法论切入，技术专题则更适合已有开发基础的学习者。" },
        { question: "企业内训和公开课有什么区别？", answer: "企业内训会用团队真实业务场景做练习，并结合行业包、诊断表与复盘模板。" },
        { question: "课程在线上还是线下进行？", answer: "个人课程以线上学习为主；企业内训可根据团队情况安排线上或线下。" },
        { question: "会用到哪些工具？", answer: "会覆盖大模型、Agent、RAG、评测与常见业务连接方式，具体工具以课程方案为准。" },
      ],
    },
    closing: { eyebrow: "开始 · GET STARTED", title: "把 AI，真正长进你的业务", primaryCta: "了解个人课程", secondaryCta: "了解企业内训" },
  },
  solutions: {
    industries: {
      eyebrow: "AI 落地行业地图",
      title: "服务各行业",
      subtitle: "从跨境电商到法律与企服财税，同一套 AI 落地方法论，适配每个行业的真实业务现场。",
      items: [
        { name: "跨境电商", description: "用 AI 串起选品、投放、内容、客服与供应链，让跨境团队更快发现机会并持续放大转化。" },
        { name: "社媒创作运营与达人营销", description: "从热点洞察、脚本生产到达人筛选与投放复盘，让内容团队稳定产出并看清每一分预算的回报。" },
        { name: "供应链", description: "把采购、仓储、订单与财务之间的断点连接起来，用 AI 加速流转、预警异常并减少人工交接。" },
        { name: "制造业", description: "将生产知识、质量流程与设备数据沉淀为可执行的 AI Agent，提升现场效率与交付稳定性。" },
        { name: "医疗健康", description: "让研发、合规、医学资料与市场信息更快检索和协同，在严格权限下缩短专业工作的响应周期。" },
        { name: "法律与企服财税", description: "自动处理合同审阅、票据分类、政策检索与凭证草拟，让专业人员把时间投入更高价值的判断。" },
        { name: "材料 / 化工工厂", description: "连接工艺知识、质量检测、生产计划与安全管理，提升现场协同与交付稳定性。" },
        { name: "高科技芯片", description: "沉淀研发文档、测试数据与工艺流程，让知识检索、问题定位和项目协作更高效。" },
        { name: "能源", description: "连接设备运维、生产调度和经营数据，提前识别风险并提升能源管理效率。" },
        { name: "工程地产", description: "协同项目计划、招采、合同与现场进度，让跨团队交付更透明可控。" },
      ],
    },
    title: "四大行业解决方案",
    subtitle: "按你的场景定制 Agent，明确周期、量化 ROI",
    items: [
      {
        title: "跨境电商",
        subtitle: "不是又一个 AI 工具，而是一支 24 小时在岗的 AI 电商团队",
        intro:
          "人定战略、下指令、看结果；重复的选品、投放、文案、客服交给 Agent——最快 2 周，5 个人也能跑出一支运营团队的产值。",
        pains: [
          { pain: "选品/竞品盯盘靠人肉复制粘贴 Excel", solution: "选品 Agent 7×24 抓取热卖与竞品，自动出爆款/机会日报" },
          { pain: "广告靠人盯大盘调价换素材", solution: "广告 Agent 实时监控 ROI、秒级调价与素材迭代" },
          { pain: "Listing/独立站文案与 SEO 写不过来", solution: "文案 Agent 批量产出地道多语文案，自带 SEO 关键词" },
          { pain: "海外达人开发群发信、跟进慢", solution: "达人 Agent 自动检索红人、批量个性化触达与跟进" },
          { pain: "多语客服倒班、退换货处理累", solution: "客服 Agent 懂多国语言、秒级响应、自动处理退换货" },
          { pain: "补货/对账/选品数据脱节", solution: "供应链 & 定价 Agent 按销售数据自动触发补货与调价、保护利润" },
        ],
        team: {
          title: "一支 AI 电商团队，多 Agent 协同",
          subtitle: "统筹 Agent 拆解目标、给各 Agent 派活并盯住异常，你只需定目标、看结果",
          roles: [
            { name: "选品 Agent", role: "研究", desc: "热卖商品 / 市场趋势 / 竞品机会" },
            { name: "广告 Agent", role: "投放", desc: "广告投放 / 预算调整 / ROI 优化" },
            { name: "店铺 Agent", role: "运营", desc: "商品上架 / Listing 优化 / 日常运营" },
            { name: "客服 Agent", role: "服务", desc: "回复客户 / 售后问题 / 工单处理" },
            { name: "定价 Agent", role: "定价", desc: "监控竞品 / 调整价格 / 保护利润" },
            { name: "统筹 Agent", role: "Supervisor", desc: "拆解目标 / 给各 Agent 派活 / 盯异常并汇报" },
          ],
        },
        security:
          "私有化部署，选品/客户/订单数据不出域、权限可控可审——比多租户 AI SaaS 更让人放心。",
        roi: "试点 3–4 周；从「一堆工具」升级为一支 AI 团队，人均产值大幅提升、无效人工大幅下降。关联案例见「客户案例」。",
      },
      {
        title: "社媒创作运营与达人营销",
        subtitle: "TikTok / Instagram 达人营销 + 内容规模化生产 + ROI 归因",
        sections: [
          {
            title: "核心痛点",
            description:
              "多账号内容产能与合规压力大、选题脚本靠人、达人投放 ROI 说不清。",
          },
          {
            title: "AI FDE 落地场景",
            description:
              "内容批量生产与合规审核、小红书/抖音选题脚本 Agent、TikTok / Instagram（INS）达人建联投放与带货、达人筛选与 ROI 归因看板。",
          },
          {
            title: "典型 Agent 能力",
            description:
              "多账号内容工厂、风控审核、脚本生成、TikTok/INS 达人筛选与私信建联、投放归因分析。",
          },
          {
            title: "预期 ROI 与交付周期",
            description: "试点 2–4 周；内容产出翻倍、人力下降、无效投放收敛。",
          },
        ],
      },
      {
        title: "供应链",
        subtitle: "给供应链配一支 AI 员工小队：录单、采购、仓储、对账，重复的活交给它",
        intro:
          "不取代人，只取代那些重复的活——AI 员工 + 真人，把人放到更值钱的判断上；最快 2 周上岗。",
        pains: [
          { pain: "客户群里五花八门下单、人工录单慢又易错", solution: "订单 Agent 自动识别、拆单建单进 ERP，7×24 群答疑" },
          { pain: "客户流失征兆藏在流水与群聊里、发现太晚", solution: "销售 Agent 分析客户健康度、自动预警、派回访任务" },
          { pain: "采购计划靠经验、询报价与供应商对接繁琐", solution: "采购 Agent 预测需求、批量询价发单、异常提醒" },
          { pain: "库存预警滞后、仓内分拣加工靠人盯", solution: "仓储 Agent 每日库存日报，软硬件打通分拣与加工" },
          { pain: "月底对账、开票、报价费时", solution: "财务 Agent 自动对账、按客户开票、10 秒出含毛利报价" },
          { pain: "经营数据滞后、老板拿不到实时账", solution: "管理 Agent 一句话查经营，自动推营收/毛利/异常客户日报" },
        ],
        team: {
          title: "一支 AI 供应链员工小队，多 Agent 协同",
          subtitle: "6 个工作组按需启用，覆盖录单到经营看板的全流程",
          roles: [
            { name: "录单 & 客服组", role: "Customer Ops", desc: "群消息自动录单 / 7×24 客户群答疑 / 签收单识别" },
            { name: "销售管理组", role: "Sales", desc: "客户健康度分析 / 流失预警 / 回访任务派发" },
            { name: "采购管理组", role: "Procurement", desc: "需求预测 / 批量询报价 / 供应商对接" },
            { name: "仓库管理组", role: "Warehouse", desc: "库存预警日报 / 分拣与加工作业（含软硬件）" },
            { name: "财务组", role: "Finance", desc: "报价测算 / 对账 / 开票核对" },
            { name: "管理组", role: "Management", desc: "一句话查经营 / 经营日报 / AI 员工汇报" },
          ],
        },
        security:
          "私有化部署、与现有 ERP 打通，订单/客户/供应商/库存等核心经营数据不出域。",
        roi: "试点 3–4 周；录入/对账/采购工时大幅下降、错发率显著降低，人均产值明显提升。",
      },
      {
        title: "法律与企服财税",
        subtitle: "把合规与记账的重复劳动交给 AI",
        sections: [
          {
            title: "核心痛点",
            description:
              "不规则票据分类难、合同风险初审耗时、地方财税政策更新快难核对。",
          },
          {
            title: "AI FDE 落地场景",
            description:
              "票据智能分类 + 科目匹配 + 凭证草稿、合同涉税/风险条款审查、财税政策精准 RAG 问答。",
          },
          {
            title: "典型 Agent 能力",
            description: "票据识别归类、凭证生成、条款风险标注、政策知识库检索。",
          },
          {
            title: "预期 ROI 与交付周期",
            description: "试点 3–4 周；记账/初审工时下降过半、政策核对成本明显降低。",
          },
        ],
      },
    ],
  },
  cases: {
    heroTitle: "AI 落地，靠交付而非概念",
    heroSubtitle:
      "从跨境电商到法律与企服财税，每个案例都从真实业务场景出发，以清晰周期和量化结果验证 AI 的价值。",
    title: "客户案例",
    subtitle: "执行而非建议——每个案例都有明确周期与量化结果",
    disclaimerNote: "部分案例为脱敏演示示意。",
    contactCta: "提交需求，了解类似案例",
    list: [
      // —— 跨境电商 ——
      {
        description:
          "某华南 3C 跨境大卖，面对多平台 Listing 产能不足与竞品差评难以及时响应的问题。FDE 交付 3 周，交付多平台 Listing 优化与竞品差评监测 Agent，接入其运营工作台。",
        tag: "AI 落地案例",
        rightText: [
          {
            title: "落地场景",
            textArr: [
              "多平台 Listing 批量优化",
              "竞品差评实时监测与预警",
              "运营工作台一键采纳建议",
            ],
          },
          {
            title: "交付方式",
            textArr: ["FDE 交付，试点 3 周", "私有化部署，接入现有运营系统"],
          },
        ],
        footerInfo: [
          "Listing 产出效率 ↑300%",
          "转化率 ↑18%",
          "竞品差评响应时效从天级缩短到小时级",
        ],
      },
      {
        description:
          "某 DTC 独立站（Shopify），弃单率高、拒付纠纷频发。FDE 交付 4 周，交付弃单挽回 + 拒付预警 Agent。",
        tag: "AI 落地案例",
        rightText: [
          {
            title: "落地场景",
            textArr: ["弃单自动挽回触达", "高风险订单拒付预警", "客服话术自动生成"],
          },
          {
            title: "交付方式",
            textArr: ["FDE 交付，试点 4 周", "对接 Shopify 与支付风控"],
          },
        ],
        footerInfo: ["弃单挽回率 ↑22%", "拒付纠纷 ↓35%", "挽回流程从人工转向自动"],
      },
      {
        description:
          "某家居出海品牌，海外达人触达低效、开发信回复率低。FDE 交付 3 周，交付 TikTok 达人自动检索 + 千人千面开发信 Agent。",
        tag: "AI 落地案例",
        rightText: [
          {
            title: "落地场景",
            textArr: [
              "TikTok 达人自动检索与画像",
              "千人千面开发信生成",
              "触达进度看板",
            ],
          },
          { title: "交付方式", textArr: ["FDE 交付，试点 3 周"] },
        ],
        footerInfo: ["达人触达量 ↑5 倍", "开发信回复率 ↑40%", "触达从人工筛选转为自动化"],
      },
      // —— 社媒创作运营与达人营销 ——
      {
        description:
          "某美妆 MCN 机构，多账号内容产能与合规审核压力大。FDE 交付 3 周，交付内容批量生产与合规审核 Agent。",
        tag: "AI 落地案例",
        rightText: [
          {
            title: "落地场景",
            textArr: ["多账号内容批量生产", "内容合规自动审核", "素材库与排期打通"],
          },
          { title: "交付方式", textArr: ["FDE 交付，试点 3 周"] },
        ],
        footerInfo: ["内容产出 ↑4 倍", "人力投入 ↓50%", "合规审核前置、风险显著下降"],
      },
      {
        description:
          "某本地生活商家，选题与脚本高度依赖人工、爆文难复制。FDE 交付 2 周，交付小红书/抖音选题与脚本 Agent。",
        tag: "AI 落地案例",
        rightText: [
          {
            title: "落地场景",
            textArr: ["平台热点选题挖掘", "分镜脚本自动生成", "爆文要素结构化沉淀"],
          },
          { title: "交付方式", textArr: ["FDE 交付，试点 2 周"] },
        ],
        footerInfo: ["爆文率 ↑2 倍", "选题到成稿周期大幅缩短", "爆文方法沉淀为可复用模板"],
      },
      {
        description:
          "某快消品牌，达人投放 ROI 难归因、无效投放多。FDE 交付 4 周，交付达人筛选与 ROI 归因看板。",
        tag: "AI 落地案例",
        rightText: [
          {
            title: "落地场景",
            textArr: ["达人筛选与风险评估", "投放 ROI 多维归因", "预算再分配建议"],
          },
          { title: "交付方式", textArr: ["FDE 交付，试点 4 周"] },
        ],
        footerInfo: ["无效投放 ↓30%", "ROI 可量化、可复盘", "预算分配从拍脑袋转向数据驱动"],
      },
      // —— 供应链 ——
      {
        description:
          "某华东农产品流通商，微信非标订单（语音/手写单）录入慢、错发多。FDE 交付 4 周，交付非标订单 → ERP 别名映射 + 一键审核卡片。",
        tag: "AI 落地案例",
        rightText: [
          {
            title: "落地场景",
            textArr: [
              "语音/手写订单解析",
              "商品别名归一映射到 ERP",
              "企微内一键审核卡片",
            ],
          },
          { title: "交付方式", textArr: ["FDE 交付，试点 4 周", "对接现有 ERP"] },
        ],
        footerInfo: ["订单录入工时 ↓70%", "错发率 ↓90%", "订单从人工录入转为自动结构化"],
      },
      {
        description:
          "某工业零配件经销商，多模态收货单对账费时、库存预警滞后。FDE 交付 3 周，交付多模态收货单解析 + 库存预警 Agent。",
        tag: "AI 落地案例",
        rightText: [
          {
            title: "落地场景",
            textArr: ["图片/PDF 收货单解析", "自动对账与差异标注", "库存阈值预警"],
          },
          { title: "交付方式", textArr: ["FDE 交付，试点 3 周"] },
        ],
        footerInfo: ["对账工时 ↓60%", "对账差异更早发现", "库存预警从被动转为主动"],
      },
      {
        description:
          "某建材供应链企业，采购—仓管—财务跨部门流转慢。FDE 交付 4 周，交付企微胶水连接器打通三方。",
        tag: "AI 落地案例",
        rightText: [
          {
            title: "落地场景",
            textArr: ["采购—仓管—财务企微连接器", "跨系统单据自动流转", "异常自动提醒"],
          },
          { title: "交付方式", textArr: ["FDE 交付，试点 4 周"] },
        ],
        footerInfo: ["跨部门流转时长 ↓65%", "单据流转全程留痕", "人工传递环节大幅减少"],
      },
      // —— 法律与企服财税 ——
      {
        description:
          "某连锁代账机构，不规则票据分类与凭证录入耗时。FDE 交付 3 周，交付票据智能分类 + 会计科目匹配 + 凭证草稿 Agent。",
        tag: "AI 落地案例",
        rightText: [
          {
            title: "落地场景",
            textArr: ["不规则票据智能分类", "会计科目自动匹配", "凭证草稿自动生成"],
          },
          { title: "交付方式", textArr: ["FDE 交付，试点 3 周"] },
        ],
        footerInfo: ["记账工时 ↓55%", "科目匹配一致性提升", "凭证从手工录入转为草稿复核"],
      },
      {
        description:
          "某区域律所，合同涉税与风险条款初审耗时长。FDE 交付 4 周，交付合同风险条款自动审查 Agent。",
        tag: "AI 落地案例",
        rightText: [
          {
            title: "落地场景",
            textArr: ["合同涉税条款识别", "风险条款自动标注", "初审意见草稿生成"],
          },
          { title: "交付方式", textArr: ["FDE 交付，试点 4 周"] },
        ],
        footerInfo: ["初审工时 ↓50%", "风险条款漏检率下降", "律师聚焦高价值判断"],
      },
      {
        description:
          "某财税咨询公司，地方财税政策更新快、核对成本高。FDE 交付 3 周，交付财税政策精准 RAG 问答 Agent。",
        tag: "AI 落地案例",
        rightText: [
          {
            title: "落地场景",
            textArr: ["地方财税政策知识库", "精准 RAG 问答与引用溯源", "政策变更提醒"],
          },
          { title: "交付方式", textArr: ["FDE 交付，试点 3 周"] },
        ],
        footerInfo: ["政策核对成本 ↓40%", "回答附政策条文出处", "政策更新响应更及时"],
      },
    ],
  },
  fde: {
    heroTitle: "FDE 交付：<span class='text-gradient'>把 AI 真正跑进业务里</span>",
    heroSubtitle:
      "前沿部署工程师交付，从业务诊断到私有化上线，专治「从试点到生产」的最后一公里。",
    whatTitle: "什么是 FDE，为什么你需要",
    whatCards: [
      {
        title: "93% 的项目卡在最后一公里",
        desc: "方案漂亮，却跑不进你的业务系统。FDE 负责把它真正落地。",
      },
      {
        title: "既懂模型，又懂你的流程",
        desc: "交付工程师深入你的场景，用工程手段把 AI 接进现有系统。",
      },
      {
        title: "明确周期、量化 ROI",
        desc: "不是交 PPT，而是交一套可度量、可迭代、跑在你系统里的 AI。",
      },
    ],
    flowTitle: "交付方法论：4 周快赢，逐步复利",
    flowSteps: ["业务诊断", "场景选型", "2–4 周快赢试点", "私有化上线", "规模化复利"],
    assetsTitle: "每次交付，沉淀为复利资产",
    assets: [
      { title: "Pre-built Agents", desc: "行业预制 Agent，开箱即用、按需微调。" },
      { title: "Harness 评测集", desc: "可复用的评测与回归集，保证效果稳定。" },
      { title: "SOP", desc: "标准作业流程，交付经验规模化复制。" },
      {
        title: "Skills & MCP 连接器",
        desc: "打通你的系统与数据的可复用连接件。",
      },
      { title: "脱敏数据集", desc: "沉淀高质量脱敏数据，越用越准。" },
    ],
    loom: {
      eyebrow: "FDE · LOOP",
      title: "让 FDE 能力持续复制，不再受规模限制",
      description:
        "把资深 FDE 的“诊断 → 拆解 → 交付 → 迭代”过程录制、回放、蒸馏为可复用 Agent，让企业的技能、知识与工作流持续沉淀、复用和进化。让人从重复执行中释放出来，把经验变成可持续增长的组织资产。",
      steps: [
        { number: "01", title: "录制", description: "采集真实业务流程、专家判断与操作步骤，完整保留现场经验。" },
        { number: "02", title: "回放", description: "把一次性交付转化为可复用、可审计、可重复执行的工作流与 Agent。" },
        { number: "03", title: "蒸馏", description: "将专家判断沉淀进 Agent，从“人来做”升级为“Agent 执行、人做兜底”。" },
        { number: "04", title: "自生长", description: "随着每次执行和复盘，Agent 复用率提升，知识、技能与流程持续变厚。" },
      ],
      record: {
        windowTitle: "loom · record",
        statusAriaLabel: "录制状态",
        status: "录制中",
        timelineLabel: "工作流时间线",
        timeline: [
          "00:02  打开 CRM，筛选高意向客户",
          "00:14  套用话术，生成报价单",
          "00:31  录入系统，触发审批流",
        ],
      },
      distill: {
        label: "蒸馏为可复用 Agent",
        prompt: "把专家判断与操作步骤整理为可审计的工作流",
        ariaLabel: "能力蒸馏阶段",
      },
      replay: {
        label: "Agent 自动回放",
        status: "运行中",
      },
      stats: {
        executionValue: "1,284",
        executionLabel: "次执行",
        humanValue: "0",
        humanLabel: "人工介入",
        progressLabel: "复用率持续提升",
        progressAriaLabel: "复用进度",
      },
      workbenchAriaLabel: "FDE Loom 工作台",
    },
    useCases: {
      eyebrow: "FDE · USE CASES",
      title: "典型应用场景",
      subtitle: "三类企业最常见的切入点，落地即可见效。",
      cards: [
        {
          number: "01",
          icon: "store",
          title: "数字化门面升级",
          description: "对外形象、询盘入口与线上转化的整体重建，让客户第一眼就建立信任。",
          tags: ["官网 / 多语言重做", "跨境商城与支付", "SEO 与询盘路径", "落地页 / 小程序"],
        },
        {
          number: "02",
          icon: "plug",
          title: "内部系统与数据打通",
          description: "把散落在表格、群聊和旧系统里的数据，整理成可用、可看、可决策的业务系统。",
          tags: ["轻量 ERP / 财务 / 审批", "打通数据孤岛", "实时业务看板", "老系统重构"],
        },
        {
          number: "03",
          icon: "workflow",
          title: "AI 工作流落地",
          description: "把 AI 嵌入日常经营，让重复劳动消失，让每个关键岗位都有专属 AI。",
          tags: ["智能客服 / 知识库", "合同 / 报价批量生成", "AI 销售辅助", "审批流程自动化"],
        },
      ],
      cta: "从你的场景开始诊断 →",
    },
    ctaText: "预约一次免费 AI 落地诊断，聊聊你的第一个快赢场景",
  },
  about: {
    heroTitle: "关于<span class='text-gradient'>乐兔智能</span>",
    heroP1:
      "乐兔智能 Letoo AI 是一家专注 AI咨询、FDE 交付与 Agent 定制开发的公司，专治 AI 落地最后一公里。",
    heroP2: "我们相信执行而非建议：用工程手段把大模型能力真正跑进企业业务系统。",
    heroP3: "使命——做 AI 落地的行动派，最后一公里的铺路人。",
    teamLabel: "我们的团队",
    investorsLabel: "我们的伙伴",
    locationsTitle: "位置",
    locations: [
      {
        name: "成都",
        detail:
          "中国（四川）自由贸易试验区成都高新区府城大道西段399号7栋1单元14楼1407号",
        country: "",
      },
    ],
    contact: [
      { text: "18180509790" },
      { text: "企业微信：扫码入群" },
      { text: "support@letoo.tech" },
    ],
  },
  community: {
    heroTitle: "开发者社群：<span class='text-gradient'>把 AI 落地能力变成收入</span>",
    heroSubtitle:
      "商机分发 · 接单 · Token 分销渠道 · 技能沉淀——和我们一起铺 AI 落地的最后一公里。",
    valueTitle: "加入你能得到什么",
    valueCards: [
      { title: "商机分发", desc: "真实企业需求持续分发，优先对接给活跃开发者。" },
      { title: "接单机会", desc: "FDE 交付项目外包与协作，能力变现。" },
      {
        title: "Token 分销渠道",
        desc: "模型与算力分销渠道，做 AI 时代的「卖水人」。",
      },
      {
        title: "技能沉淀",
        desc: "共享 Pre-built Agents、SOP、Skills & MCP 连接器。",
      },
    ],
    joinTitle: "如何入群",
    joinDesc: "扫码添加企业微信，通过后拉你进开发者私域社群。",
    qrCaption: "企业微信 · 扫码入群",
    rulesTitle: "社群规则",
    rules: [
      "真实身份、真诚协作，禁止硬广与刷屏。",
      "接单以交付质量为先，尊重客户与队友。",
      "技能与经验乐于分享，共建复利资产。",
    ],
    ctaText: "先加企业微信，进群看看真实商机",
  },
  footer: {
    description:
      "企业级AI（FDE）交付，从业务诊断到私有化上线，帮你把 AI 真正长进业务里。",
    contact: "联系我们",
    groups: {
      product: { title: "产品与服务" },
      learn: { title: "探索 Letoo AI" },
    },
    ecosystem: {
      title: "AI 落地生态",
      description: "连接业务、Agent、数据与交付，让每一次 AI 实践都沉淀为可复用的能力。",
      badge: "AI-native delivery",
    },
    copyright: "© {year} {brand} · 保留所有权利",
    bottomNote: "蜀ICP备2026000935号-2",
    publicSecurityFiling: "川公网安备51019002010054号",
  },
  meta: {
    home: {
      title: "首页",
      desc: "乐兔智能 Letoo AI：不止给建议，帮你把 AI 真正长进业务里。FDE 交付，最快 2 周见效。",
    },
    solutions: {
      title: "解决方案",
      desc: "四大行业 AI 落地解决方案：按场景定制 Agent，明确周期、量化 ROI。",
    },
    cases: {
      title: "客户案例",
      desc: "跨境电商、社媒、供应链、法律企服财税四大行业的 AI 落地案例，明确周期与量化 ROI。",
    },
    fde: {
      title: "FDE 交付",
      desc: "前沿部署工程师交付，从业务诊断到私有化上线，专治 AI 落地最后一公里。",
    },
    community: {
      title: "开发者社群",
      desc: "商机分发、接单、Token 分销与技能沉淀，加入乐兔智能 Letoo AI 开发者社群。",
    },
    about: {
      title: "关于我们",
      desc: "乐兔智能 Letoo AI：AI 落地行动派，最后一公里的铺路人。",
    },
  },
};
